export default {
  Home: 'Home',
  Mobile: 'Mobile',
  Work: 'Work',
} as const;
